$( document ).ready(function() {
  $('.template-product fieldset.product-variant-picker-block:nth-of-type(2) .variant-input').addClass( "sold-out" );
  var selectedOption1 = $('[x-ref="singleVariantSelector"] option:selected').attr('data-option1');
  let myArray = $('[x-ref="singleVariantSelector"]').find('[data-option1="' + selectedOption1 + '"]:not([disabled])');
  jQuery.each(myArray, function(index, item) {
    var selectedOption2 = item.dataset.option2;      
    $('fieldset.product-variant-picker-block:nth-of-type(2) [data-option-value="' + selectedOption2 + '"]').removeClass( "sold-out" );
  });
  const skipLink = document.querySelector(".skip-link");
  document.body.insertBefore(skipLink, document.body.firstChild);
  setTimeout(function(){
    document.body.insertBefore(skipLink, document.body.firstChild);
    
    var klReviewsSortLabel = document.createElement("Label");
    klReviewsSortLabel.setAttribute("for","kl_reviews__sort_by_reviews");
    klReviewsSortLabel.innerHTML = "Sort reviews by";
    klReviewsSortLabel.classList.add("visually-hidden")
    var klReviewsSort = document.querySelector('#kl_reviews__sort_by_reviews'); 
    if(klReviewsSort){
      klReviewsSort.insertAdjacentElement('beforebegin', klReviewsSortLabel);
    }

    var klReviewsFilterRatingLabel = document.createElement("Label");
    klReviewsFilterRatingLabel.setAttribute("for","kl_reviews__filter_reviews_rating");
    klReviewsFilterRatingLabel.innerHTML = "Filter reviews by rating";
    klReviewsFilterRatingLabel.classList.add("visually-hidden")
    var klReviewsFilterRating = document.querySelector('#kl_reviews__filter_reviews_rating'); 
    if(klReviewsFilterRating) {
      klReviewsFilterRating.insertAdjacentElement('beforebegin', klReviewsFilterRatingLabel);
    }
    
    var klReviewsFilterVariantLabel = document.createElement("Label");
    klReviewsFilterVariantLabel.setAttribute("for","kl_reviews__filter_reviews_variant");
    klReviewsFilterVariantLabel.innerHTML = "Filter reviews by rating";
    klReviewsFilterVariantLabel.classList.add("visually-hidden")
    var klReviewsFilterVariant = document.querySelector('#kl_reviews__filter_reviews_variant'); 
    if(klReviewsFilterVariant){
      klReviewsFilterVariant.insertAdjacentElement('beforebegin', klReviewsFilterVariantLabel); 
    }
       
  }, 2000);
});

$('.template-product fieldset.product-variant-picker-block:nth-of-type(1) .variant-input').on('click', function() {
  $('fieldset.product-variant-picker-block:nth-of-type(2) .variant-input').addClass( "sold-out" );
    var selectedOption1 = $('fieldset.product-variant-picker-block:nth-of-type(1) input:checked').attr('value');
    let myArray = $('[x-ref="singleVariantSelector"]').find('[data-option1="' + selectedOption1 + '"]:not([disabled])');
    jQuery.each(myArray, function(index, item) {
      var selectedOption2 = item.dataset.option2;      
      $('fieldset.product-variant-picker-block:nth-of-type(2) [data-option-value="' + selectedOption2 + '"]').removeClass( "sold-out" );
    });
});

document.body.addEventListener('baseline:modalcart:afteradditem', function () {
  let upsellDrawer = document.querySelector("#upsellplus_drawer_offer");
  if (upsellDrawer) {

  } else {
    upsellplusapp.init_drawer_offer();
  }
});

document.body.addEventListener('baseline:modalcart:itemcountupdate', function () {
  let upsellDrawer = document.querySelector("#upsellplus_drawer_offer");
  if (upsellDrawer) {
    upsellDrawer.innerHTML = "";
    upsellplusapp.init_drawer_offer();
  } else {
    if (typeof upsellplusapp == 'object') {
      upsellplusapp.init_drawer_offer();
    }
  }
});